import React from 'react';
import { CloudUploadOutlined } from '@ant-design/icons';
import { fileTypeHint } from './index';

/**
 * Shared click target rendered inside an antd <Upload>. Replaces the old dark
 * `backgroundColor: '#333'` buttons so every upload across the app looks the same.
 *
 * @param label    Primary line. Defaults to "Browse for file".
 * @param fileType Key from FILE_TYPE_RULES ('image' | 'docType' | 'txtType' |
 *                 'onlyCSV' | 'onlyXls' | 'bookImage'). Drives the hint line so it
 *                 always matches what `beforeUpload` actually accepts.
 * @param hint     Overrides the derived hint. Use only when the accepted formats
 *                 cannot be expressed by a fileType key.
 * @param disabled Dims the trigger. Pass alongside <Upload disabled> — this prop
 *                 only styles the trigger, it does not block the upload itself.
 */
const UploadTrigger = ({ label = 'Browse for file', hint, fileType = 'image', disabled = false }) => (
  <div className={disabled ? 'bp-upload-trigger bp-upload-trigger--disabled' : 'bp-upload-trigger'}>
    <CloudUploadOutlined className="bp-upload-trigger-icon" />
    <div className="bp-upload-trigger-text">
      <span>{label}</span>
      <small>{hint || fileTypeHint(fileType)}</small>
    </div>
  </div>
);

export default UploadTrigger;
